export const leftSubMenu = {
    home: [],
    users: [
        { name: 'Enrolled', isActive: false, nav: 'users/enrolled', privilege: 'users_Enrolled' },
        { name: 'Pending', isActive: false, nav: 'users/pending', privilege: 'users_Pending' },
        { name: 'Rejected', isActive: false, nav: 'users/rejected', privilege: 'users_Rejected' },
        { name: 'Archived Users', isActive: false, nav: 'users/inactive', privilege: 'users_ArchivedUsers' }
    ],
    settings: [
        { name: 'Alert Rules', isActive: false, nav: 'settings/alertRule', privilege: 'settings_AlertRules' },
        { name: 'Configurations', isActive: false, nav: 'settings/configuration', privilege: 'settings_Configurations' },
        { name: 'Roles', isActive: false, nav: 'settings/role', privilege: 'settings_Roles' },
        { name: 'Trades', isActive: false, nav: 'settings/trade', privilege: 'settings_Trades' },
        { name: 'Role Types', isActive: false, nav: 'settings/roleType', privilege: 'settings_RoleTypes' },
        { name: 'Features', isActive: false, nav: 'settings/feature', privilege: 'settings_Features' },
        { name: 'User Groups', isActive: false, nav: 'settings/userGroup', privilege: 'settings_UserGroups' },
        { name: 'Device Apps', isActive: false, nav: 'settings/deviceApp', privilege: 'settings_DeviceApps' },
        { name: 'Error Codes', isActive: false, nav: 'settings/errorCodes', privilege: 'settings_ErrorCodes' },
        { name: 'Controls', isActive: false, nav: 'settings/control', privilege: 'settings_Controls' },
        { name: 'Alert Control', isActive: false, nav: 'settings/alertControl', privilege: 'settings_AlertControl' },
        { name: 'Icon/Image Upload', isActive: false, nav: 'settings/imageUpload', privilege: 'settings_Icon/ImageUpload' },
    ],
    plants: [
        { name: 'Enrolled', isActive: false, nav: 'plants/active', privilege: 'sites_Enrolled' },
        { name: 'Archived', isActive: false, nav: 'plants/inactive', privilege: 'sites_Archived' }
    ],
    vehicles: [
        { name: 'Enrolled Vehicles', isActive: false, nav: 'vehicles/active', privilege: 'vehicles_Enrolled' },
        { name: 'Archived Vehicles', isActive: false, nav: 'vehicles/inactive', privilege: 'vehicles_Archived' },
        { name: 'Blueprint', isActive: false, nav: 'vehicles/blueprint', privilege: 'vehicles_Blueprint' }
    ],
    assets: [
        { name: 'Enrolled', isActive: false, nav: 'assets/active', privilege: 'assets_Enrolled' },
        { name: 'Blueprint', isActive: false, nav: 'assets/blueprint', privilege: 'assets_Blueprint' },
        { name: 'Archived', isActive: false, nav: 'assets/inactive', privilege: 'assets_Archived' }
    ],
    people: [
        { name: 'Enrolled', isActive: false, nav: 'people/active', privilege: 'people_Enrolled' },
        { name: 'Archived', isActive: false, nav: 'people/inactive', privilege: 'people_Archived' }
    ],
    events: [
        { name: 'Alerts', isActive: false, nav: 'events/alerts', privilege: 'events_alerts' },
    ],
    tracker: [],
    wiki: [
        { name: 'Library', isActive: false, nav: 'wiki/library', privilege: 'knowledgebase_Library' },
        { name: 'Studio', isActive: false, nav: 'wiki/studio', privilege: 'knowledgebase_Studio' }
    ],
    analytics: [
        { name: 'Self Service', isActive: false, nav: 'analytics/selfService', privilege: 'analytics_SelfService'},
        { name: 'Comparative Analysis', isActive: false, nav: 'analytics/comparativeAnalysis', privilege: 'analytics_ComparativeAnalysis' },
        { name: 'Recurring DTCs', isActive: false, nav: 'analytics/analysis1', privilege: 'analytics_Analysis1' },
        { name: 'Demographic Insights', isActive: false, nav: 'analytics/analysis2', privilege: 'analytics_Analysis2' },
        { name: 'Usage-Based Analysis', isActive: false, nav: 'analytics/analysis3', privilege: 'analytics_Analysis3' },
        { name: 'DTC Prioritization', isActive: false, nav: 'analytics/analysis4', privilege: 'analytics_Analysis4' },
        { name: 'DTC Analysis', isActive: false, nav: 'analytics/analysis5', privilege: 'analytics_Analysis5' },
        { name: 'Reports', isActive: false, nav: 'analytics/reports', privilege: 'analytics_Reports' },
    ],
    devices: [],
    developer: [
        // { name: 'Data Ingestion Stats', isActive: false, nav: '/developer/dataIngestion' },
        // { name: 'Device Data Storage', isActive: false, nav: '/developer/dataStorage' }
    ],
    dtc: [],
    case: [],
    rules: [],
    protus: [],
    log: []
}